import { useTheme } from "@mui/material";
import { useRef } from "react";
import { Sheet, SheetRef } from "react-modal-sheet";
import ModalHeader from "@/modules/common/components/ui-kit/modals/modal-header";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

interface CommonBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  snapPoints?: number[];
  initialSnap?: number;
}

const CommonBottomSheet = ({
  isOpen,
  onClose,
  children,
  title,
  snapPoints = [0.4, 0.8],
  initialSnap = 0,
}: CommonBottomSheetProps) => {
  const theme = useTheme();

  const sheetRef = useRef<SheetRef>(null);

  return (
    <Sheet
      ref={sheetRef}
      isOpen={isOpen}
      onClose={onClose}
      snapPoints={snapPoints}
      initialSnap={initialSnap}
      style={{
        zIndex: theme.zIndex.modal,
      }}
    >
      <Sheet.Container
        style={{
          backgroundColor: nawyTheme.nawy.colors.semantic.layer.primary,
          borderTopLeftRadius: nawyTheme.nawy.radius["2xl"],
          borderTopRightRadius: nawyTheme.nawy.radius["2xl"],
        }}
      >
        <Sheet.Header
          style={{
            backgroundColor: nawyTheme.nawy.colors.semantic.layer.primary,
            borderTopLeftRadius: nawyTheme.nawy.radius["2xl"],
            borderTopRightRadius: nawyTheme.nawy.radius["2xl"],
          }}
        />
        <Sheet.Content
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
          }}
        >
          {title && <ModalHeader title={title} onClose={onClose} />}
          <Sheet.Scroller>{children}</Sheet.Scroller>
        </Sheet.Content>
      </Sheet.Container>

      <Sheet.Backdrop onTap={onClose} />
    </Sheet>
  );
};

export default CommonBottomSheet;
